import 'url-polyfill';

import * as Integrations from '@sentry/integrations';
import * as Sentry from '@sentry/browser';
import App from '@/views/App';
import { HTTPCancelMixin } from '@/mixins/HTTPCancelMixin';
import { ScreenSizeMixin } from '@/mixins/ScreenSizeMixin';
import Vue from 'vue';
import config from '@/config';
import { createRouter } from '@/router';
import { createStore } from '@/store';
import { install as installPlugins } from '@/plugins';
import { setFilters } from '@/filters';

Vue.config.productionTip = false;

// Set filters
setFilters();

// Install all plugins
installPlugins(Vue);

// Create Store
const store = createStore();

// Install router
const router = createRouter(store);

// Register global mixins
Vue.mixin(HTTPCancelMixin);
Vue.mixin(ScreenSizeMixin);

// Unregister service workers
if (window.navigator && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });
}

console.log('Release', config.appVersion);

if (config.sentryDsn) {
  Sentry.init({
    environment: config.env,
    release: config.appVersion,
    dsn: config.sentryDsn,
    debug: config.sentryDebug,
    integrations: [new Integrations.Vue({Vue, attachProps: true })],
  });

  Sentry.configureScope((s) => s.setTag('transaction_id', config.transactionId));
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
